import React from "react";
import { Btn } from "../styles/Button.styled";

export default function Button(props: ButtonProps) {
  return (
    <Btn
      $background={`var(--${props.bgcolor})`}
      type= {props.$type ? props.$type : "button"}
      onClick={props.onClick}
      $width={props.$width }
      $height={props.$height}
      $color={props.$color}
      disabled={props.disabled}
      $disabledColor={props.disabledColor}
      $disabledC={props.$disabledC}
      $marginTop={props.$marginTop}
      $heightMobile= {props.$heightMobile}     
    >
      {props.title}
    </Btn>
  );
}
